// removed by extract-text-webpack-plugin
module.exports = {"page":"_3WTk0","frontend":"_1HaQM","playing":"_3MVJY","skipped":"_3gx45","skippedDue":"_12FC0","skippedReasons":"_2qyBW","error":"SWRH5","conflict":"_2Yz-h"};


//////////////////
// WEBPACK FOOTER
// ./src/components/present/ChannelDebug.css
// module id = 834
// module chunks = 0